import ActionButton from '@/components/bundles/share/grid/ActionButton.js'
import Grid from "../../../share/grid/Grid.vue";
import Page from "../../../../share/content/Page";
import MakeModal from "./modal/Make.vue";
import ModelModal from "./modal/Model.vue";

export default {
  template: `
    <div v-if="showGrid">
        <section class="content">
            <div class="row">
                <div class="col-sm-12">
                    <div class="box box-default box-solid">
                        <div class="box-body table-responsive">
                            <grid :source="gridDataSource"
                                  :name="gridName"
                                  :columns="gridColumns"
                                  :defaultOrder="[[1, 'asc']]">
                            </grid>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <make-modal :show="modalMakeVisible"
                    @close="modalMakeVisible = false"
                    mode="new"
                    :service="service">
        </make-modal>
        <model-modal :show="modalModelVisible"
                    @close="modalModelVisible = false"
                    mode="new"
                    :service="service">
        </model-modal>
    </div>`,
  components: {
    Grid,
    MakeModal,
    ModelModal
  },
  mixins: [
    Page,
    ActionButton
  ],
  data() {
    return {
      events: {
        addMake: "core:vehicle:addMake",
        addModel: "core:vehicle:addModel"
      },
      modalMakeVisible: false,
      modalModelVisible: false,
      showGrid: true
    };
  },
  mounted() {
    this.$events.on(this.events.addMake, this.addMake);
    this.$events.on(this.events.addModel, this.addModel);
  },
  computed: {
    gridDataSource() {
      const vm = this;
      return { service: vm.service, url: "/vehicles" };
    },
    gridColumns() {
      return [
        {
          id: 0,
          data: 'DT_RowId',
          title: '',
          searchable: false,
          orderable: false,
          render: () => { return '' }
        },
        { id: 1, data: "make", title: this.$t("pages.vehicles.make") },
        { id: 2, data: "model", title: this.$t("pages.vehicles.model") },
        {
          id: 3,
          data: "vehicleType",
          title: this.$t("pages.vehicles.vehicleType"),
          render: (data) => {
            const vehicleTypes = {
              1: this.$t("pages.vehicles.car"),
              2: this.$t("pages.vehicles.truck")
            };
            return vehicleTypes[data];
          }
        }
      ]
    }
  },
  methods: {
    addMake() {
      this.modalMakeVisible = true;
    },
    addModel() {
      this.modalModelVisible = true;
    },
    actionShow(id) {
      const vm = this;
      this.$router.push({ name: vm.actionShowUrlName, params: { id } });
    }
  }
};
